<template>
  <v-container>
    <div class="mt-4">
      <h1 class="text-center">Réinitialisation de mot de passe</h1>
      <div class="d-flex">
        <v-spacer />
        <v-form ref="form" class="login">
          <v-fade-transition mode="out-in">
            <a-authorization-card
              v-if="chargement"
              class="ma-5"
              color="secondary"
              icon="mdi-arrow-decision"
              text="Récupération des informations d'authentification en cours."
              sub="Cela peut prendre quelques instants."
            />
            <a-authorization-card
              v-else-if="erreur"
              class="ma-5"
              color="error"
              icon="mdi-account-alert-outline"
            >
              <p>Ce lien a déjà été utilisé ou a expiré.</p>
              <p>En cas de problème technique merci de contacter le support EPELFI.</p>
            </a-authorization-card>
            <div v-else-if="formulaire">
              <v-card-text>
                <p>Veuillez saisir votre nouveau mot de passe.</p>
                <a-motpasse-utilisateur-row v-model="info" />
              </v-card-text>
              <v-card-text class="d-flex">
                <router-link to="/accueil">Annuler</router-link>
                <v-spacer />
                <v-btn data-testid="valider" @click="valider" :loading="working" color="primary">
                  Valider
                </v-btn>
              </v-card-text>
            </div>
            <div v-else>
              <v-card-text>
                <p>
                  Votre mot de passe a été changé, vous pouvez dorénavant vous identifier
                  avec celui-ci.
                </p>
                <p>
                  <router-link to="/accueil">Retour à l'accueil</router-link>
                </p>
              </v-card-text>
            </div>
          </v-fade-transition>
        </v-form>
        <v-spacer />
      </div>
    </div>
  </v-container>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import { utilisateurCycleService } from "@/services";
export default {
  mixins: [makeRemoteWorker()],
  data() {
    return {
      info: {
        motPasse: "",
      },
      code: null,
      formulaire: true,
      chargement: false,
      erreur: false,
    };
  },
  mounted() {
    const url = window.location.search;

    //suppression des paramètres state et code de l'URL
    window.history.replaceState({}, {}, "/accueil");

    const group = url.match(/.*\?(.+)/);
    if (group) {
      const params = new URLSearchParams(group[1]);
      this.code = params.get("code");

      this.erreur = false;
      this.chargement = true;
      utilisateurCycleService
        .existeReinitMotPasse(this.code)
        .then(() => {
          this.erreur = false;
        })
        .catch(() => {
          this.erreur = true;
        })
        .finally(() => {
          this.chargement = false;
        });
    } else {
      this.erreur = true;
    }
  },
  methods: {
    valider() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return utilisateurCycleService.reinitOubli(this.code, this.info.motPasse);
        },
        callback() {
          this.formulaire = false;
        },
        successText: "Votre mot de passe a été changé.",
        errorText: "Erreur durant la réinitialisation du mot de passe",
      });
    },
  },
};
</script>
